import { Phone, Navigation, Car } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { BUSINESS } from "../data/site";

export const StickyMobileBar = () => {
  const navigate = useNavigate();
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed bottom-0 inset-x-0 z-50 md:hidden border-t border-line bg-white/90 backdrop-blur-xl"
    >
      <div className="grid grid-cols-3 divide-x divide-line">
        <a
          data-testid="sticky-call-button"
          href={BUSINESS.phoneHref}
          className="flex flex-col items-center gap-1 py-3 text-volt active:bg-white/5"
        >
          <Phone className="w-5 h-5" />
          <span className="font-mono text-[10px] font-bold uppercase tracking-[0.18em]">Call</span>
        </a>
        <a
          data-testid="sticky-directions-button"
          href={BUSINESS.mapsDirections}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center gap-1 py-3 text-ink active:bg-ink/5"
        >
          <Navigation className="w-5 h-5" />
          <span className="font-mono text-[10px] font-bold uppercase tracking-[0.18em]">Directions</span>
        </a>
        <button
          data-testid="sticky-smogcheck-button"
          onClick={() => navigate("/contact")}
          className="flex flex-col items-center gap-1 py-3 bg-volt text-white active:bg-volt-hover"
        >
          <Car className="w-5 h-5" />
          <span className="font-mono text-[10px] font-bold uppercase tracking-[0.18em]">Smog Check</span>
        </button>
      </div>
    </div>
  );
};
